import { PaymentFeeRail } from "../types/paymentFees.types";
import { RAIL_COUNTRY } from "./paymentRails.constants";

/** The corridor countries the backend's `Country` enum accepts, and the currency their corridors move. */
export const TAX_COUNTRIES = [
  { iso3: "COL", iso2: "CO", currency: "COP" },
  { iso3: "MEX", iso2: "MX", currency: "MXN" },
  { iso3: "BRA", iso2: "BR", currency: "BRL" },
  { iso3: "ARG", iso2: "AR", currency: "ARS" },
] as const;

/** The commission the "on the commission" example is worked on, in the country's currency. */
export const EXAMPLE_COMMISSION = "1000";

export function currencyOfCountry(iso3: string): string {
  return TAX_COUNTRIES.find((country) => country.iso3 === iso3)?.currency ?? "";
}

export function railsOfCountry(iso3: string): PaymentFeeRail[] {
  const iso2 = TAX_COUNTRIES.find((country) => country.iso3 === iso3)?.iso2;
  return Object.values(PaymentFeeRail).filter((rail) => RAIL_COUNTRY[rail]?.iso2 === iso2);
}

export function countryLabel(iso3: string, locale: string): string {
  const iso2 = TAX_COUNTRIES.find((country) => country.iso3 === iso3)?.iso2;
  if (!iso2) return iso3;
  return new Intl.DisplayNames([locale], { type: "region" }).of(iso2) ?? iso3;
}
